import { Table, TableBody, TableCell, TableHeader, TableRow } from '@/components/ui/table';
import { ArrowDown } from 'lucide-react';
import { Transaction } from './budget-data';
import { AccountType, useCurrencyFormatter } from '@liquidbudget/common';
import { getAccountTypeIcon } from '@/components/account-form/account-icon';

type Props = {
  transactions: Transaction[];
};

export function TransactionTable({ transactions }: Props) {
  const formatCurrency = useCurrencyFormatter();

  return (
    <Table className="bg-accent text-md">
      <TableHeader>
        <TableRow>
          <TableCell className="font-bold hidden md:table-cell h-10">Date</TableCell>
          <TableCell className="font-bold hidden md:table-cell">Account</TableCell>
          <TableCell className="font-bold pr-5">Payee</TableCell>
          <TableCell className="font-bold pr-5">Type</TableCell>
          <TableCell className="text-right font-bold pr-5">Outflow</TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {transactions.map((transaction) => {
          const AccountIcon = getAccountTypeIcon(transaction.accountType as AccountType);

          return (
            <TableRow className=" bg-white dark:bg-black/50" key={transaction.payee}>
              <TableCell className="font-semibold hidden md:table-cell">{transaction.date}</TableCell>
              <TableCell className="text-md hidden md:table-cell">
                <AccountIcon className="inline text-gray-400 w-7 h-7 pr-2 " /> {transaction.account}
              </TableCell>
              <TableCell className="">{transaction.payee}</TableCell>
              <TableCell className="">
                <div className="flex items-center">
                  <ArrowDown className="w-3 h-3 text-rose-800" />
                  <div className="flex flex-col ml-2">
                    <span className="text-sm text-muted-foreground">{transaction?.category}</span>
                    <span className="font-medium">{transaction?.bucket}</span>
                  </div>
                </div>
              </TableCell>
              <TableCell className="text-right pr-5 text-md text-rose-800 font-semibold">
                {formatCurrency(transaction.outflow)}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
